import { PaletteColor, SxProps, useTheme } from '@mui/material'
import { MainMaterialColor, MaterialColor } from '~/theme/default'
import icons from '~/assets/icons'
import LocalSVGIcon from './LocalSVGIcon'
import Icon8 from './Icon8'

export interface Props {
  name: keyof typeof icons
  color?: MaterialColor
  size?: number
  scale?: number
  sx?: SxProps
}

export default function StyledIcon(props: Props) {
  const theme = useTheme()
  const { scale = 2, color, name, size = 30, sx } = props
  const path = icons[name as keyof typeof icons]

  if (!path) {
    console.error(`No icon found for name ${name}`)
    return null
  }

  const parts = path.split('/')
  const [family] = parts

  const [mainColor = 'darkGray', secondaryColor = 'main'] = color?.split('.') || []

  const themedColor = theme.palette[mainColor as MainMaterialColor]?.[secondaryColor as keyof PaletteColor] || color

  if (family === 'local') {
    return <LocalSVGIcon color={themedColor} name={name} size={size} />
  }

  return (
    <Icon8 name={name} color={themedColor} size={size} scale={scale} sx={sx} />
  )
}
